"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataAccessorImpl = void 0;
const types_1 = require("@refinitiv-data/types");
const endpoint_request_1 = require("../../delivery/endpoint-request");
class DataAccessorImpl {
    constructor(session) {
        this.session = session;
    }
    async getData(request) {
        return endpoint_request_1.EndpointRequest.Definition({
            url: request.url,
            method: request.method || types_1.HttpMethod.GET,
            queryParameters: request.dataAccessorContentQuery,
            bodyParameters: request.dataAccessorContentBody,
        }).getData(this.session);
    }
}
exports.DataAccessorImpl = DataAccessorImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0YS1hY2Nlc3Nvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2RhdGEtYWNjZXNzb3IvZGF0YS1hY2Nlc3Nvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxpREFBOEU7QUFFOUUsc0VBQWtFO0FBR2xFLE1BQWEsZ0JBQWdCO0lBQ3pCLFlBQW9CLE9BQWdCO1FBQWhCLFlBQU8sR0FBUCxPQUFPLENBQVM7SUFBRyxDQUFDO0lBRWpDLEtBQUssQ0FBQyxPQUFPLENBQ2hCLE9BQWlCO1FBRWpCLE9BQU8sa0NBQWUsQ0FBQyxVQUFVLENBQUM7WUFDOUIsR0FBRyxFQUFFLE9BQU8sQ0FBQyxHQUFHO1lBQ2hCLE1BQU0sRUFBRSxPQUFPLENBQUMsTUFBTSxJQUFJLGtCQUFVLENBQUMsR0FBRztZQUN4QyxlQUFlLEVBQUUsT0FBTyxDQUFDLHdCQUF3QjtZQUNqRCxjQUFjLEVBQUUsT0FBTyxDQUFDLHVCQUF1QjtTQUNsRCxDQUFDLENBQUMsT0FBTyxDQUFNLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUNsQyxDQUFDO0NBQ0o7QUFiRCw0Q0FhQyJ9